export function setLogin(secondsUntilLogout: number): void {
    if (typeof secondsUntilLogout !== "number" || isNaN(secondsUntilLogout)) {
        throw new Error("secondsUntilLogout must be a valid number");
    }
    let logoutTime = new Date();
    logoutTime.setSeconds(logoutTime.getSeconds() + secondsUntilLogout);
    localStorage.setItem("loggedIn", logoutTime.toISOString());
}

export function hasLocalLoginToken(): boolean {
    const storageItem: string | null = localStorage.getItem("loggedIn");
    if (storageItem == null) {
        return false;
    }
    const logoutTime: Date = new Date(storageItem);
    if (logoutTime.getTime() < Date.now()) {
        setLogout();
        return false;
    }
    return true;
}

export function setLogout(): void {
    localStorage.removeItem("loggedIn");
}
